import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginButton from './LoginButton';

interface AuthButtonsProps {
  className?: string;
}

/**
 * ProSpliceWEB標準の認証ボタン
 * 既存の01_app_splicewebデザインに準拠
 */
const AuthButtons: React.FC<AuthButtonsProps> = ({ 
  className = ''
}) => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  // ログアウト処理
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('ログアウト処理でエラーが発生しました:', error);
      }
    } finally {
      // ログアウト後にトップページに遷移（エラーが発生してもリダイレクト）
      navigate('/');
    }
  };

  return (
    <ul className={`navbar-nav ${className}`}>
      {isAuthenticated && user ? (
        // ログイン済みの場合：マイページボタン（ドロップダウン付き）
        <li className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle d-flex align-items-center"
            to="/mypage"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fas fa-user-circle me-2"></i>
            マイページ
          </Link>
          <ul className="dropdown-menu dropdown-menu-end shadow">
            <li>
              <Link className="dropdown-item" to="/mypage">
                <i className="fas fa-user-circle me-2"></i>
                マイページ
              </Link>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <span className="dropdown-item-text text-muted small">
                <i className="fas fa-user me-2"></i>
                {user?.display_name || user?.username}
              </span>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button 
                className="dropdown-item"
                onClick={handleLogout}
              >
                <i className="fas fa-sign-out-alt me-2"></i>
                ログアウト
              </button>
            </li>
          </ul>
        </li>
      ) : (
        // 未ログインの場合：ログインボタン
        <li className="nav-item">
          <LoginButton />
        </li>
      )}
    </ul>
  );
};

export default AuthButtons;